import PricingRule from './PricingRule'

export default PricingRule
